/**
 * @file Service for current resource
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { AuthenticationService } from './authentication.service';
import { UserService } from './user.service';
var ResourceService = /** @class */ (function () {
    /**
    * Creates an instance of ResourceService.
    * @param {SettingsService} settingsService
    * @param {AuthenticationService} authenticationService
    * @param {UserService} userService
    * @memberof ResourceService
    */
    function ResourceService(authenticationService, userService) {
        this.authenticationService = authenticationService;
        this.userService = userService;
    }
    /**
    * Methode is part of Bootflow in app.module.ts
    */
    ResourceService.prototype.bootInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadResource()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ResourceService.prototype.loadResource = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!this.authenticationService.isAuthenticated()) {
                    throw new Error('Can not load the Resource because the current user is unauthenticated');
                }
                if (!this.userService.hasAuthenticatedUser()) {
                    throw new Error('Loading the Resource is only possible if there is an Authenticated user');
                }
                this.resource = this.userService.getResourceOfUser();
                return [2 /*return*/];
            });
        });
    };
    ResourceService.prototype.getResourceOid = function () {
        return this.userService.resourceOid;
    };
    return ResourceService;
}());
export { ResourceService };
